import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { NotificationProvider } from "./context/NotificationContext";
import ComingSoonModal from "./components/ComingSoonModal";
import HomePage from "./user_pages/HomePage";
import Biography from "./user_pages/Biography";
import Music from "./user_pages/Music";
import MusicDetails from "./user_pages/MusicDetails";
import Events from "./user_pages/Events";
import Images from "./user_pages/Images";
import Videos from "./user_pages/Videos";
import Shop from "./user_pages/Shop";
import ProductDetails from "./user_pages/ProductDetails";
import Checkout from "./user_pages/Checkout";
import Press from "./user_pages/Press";
import Contact from "./user_pages/Contact";
import PrivacyPolicy from "./user_pages/PrivacyPolicy";
import TermsOfService from "./user_pages/TermsOfService";
import LoginPage from "./user_pages/LoginPage";
import ForgotPasswordPage from "./user_pages/ForgotPasswordPage";
import ResetPasswordPage from "./user_pages/ResetPasswordPage";
import UserDashboard from "./user_pages/UserDashboard";
import OrderHistory from "./user_pages/OrderHistory";
import UserChangePassword from "./user_pages/ChangePassword";
import { UserProtectedRoutes, UserPublicRoutes } from "./components/user/UserProtectedRoutes";
import { CartProvider } from "./context/CartContext";

// Admin Pages
import Dashboard from "./admin_pages/Dashboard";
import DiscographyPage from "./admin_pages/Discography/DiscographyPage";
import AddMusicPage from "./admin_pages/Discography/AddMusicPage";
import EditMusicPage from "./admin_pages/Discography/EditMusicPage";
import EventsPage from "./admin_pages/Events/EventsPage";
import AddEventPage from "./admin_pages/Events/AddEventPage";
import EditEventPage from "./admin_pages/Events/EditEventPage";
import CategoriesPage from './admin_pages/Inventory/CategoriesPage';
import MusicContentPage from './admin_pages/Inventory/MusicContentPage';
import ArtistMerchPage from './admin_pages/Inventory/ArtistMerchPage';
import AllProductsPage from './admin_pages/Inventory/AllProductsPage';
import GalleryPage from "./admin_pages/Gallery/GalleryPage";
import AddGalleryItemPage from "./admin_pages/Gallery/AddGalleryItemPage";
import EditGalleryItemPage from "./admin_pages/Gallery/EditGalleryItemPage";
import PressPage from "./admin_pages/Press/PressPage";
import SubscribersPage from "./admin_pages/Subscribers/SubscribersPage";
import AddPressPage from "./admin_pages/Press/AddPressPage";
import EditPressPage from "./admin_pages/Press/EditPressPage";
import AddQuotePage from "./admin_pages/Press/AddQuotePage";
import EditQuotePage from "./admin_pages/Press/EditQuotePage";
import AdminLogin from "./admin_pages/AdminLogin";
import ForgotPassword from "./admin_pages/ForgotPassword";
import ResetPassword from "./admin_pages/ResetPassword";
import ChangePassword from "./admin_pages/ChangePassword";
import OrdersPage from "./admin_pages/Orders/OrdersPage";
import OrderDetailsPage from "./admin_pages/Orders/OrderDetailsPage";
import ContactsPage from "./admin_pages/Contacts/ContactsPage";
import ContactDetailsPage from "./admin_pages/Contacts/ContactDetailsPage";
import AdminPublicRoutes from "./components/admin/AdminPublicRoutes";
import AdminProtectedRoutes from "./components/admin/AdminProtectedRoutes";
import NotFound from "./user_pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import ContactPageSetting from "./admin_pages/Settings/ContactPageSetting";
import BiographyPageSetting from "./admin_pages/Settings/BiographyPageSetting";
import HomepageSectionSetting from "./admin_pages/Settings/HomepageSectionSetting";
import AdminLayout from "./components/admin/AdminLayout";
import EpkManagementPage from "./admin_pages/Press/EpkManagementPage";
import AddEpkPage from "./admin_pages/Press/AddEpkPage";








const AppRoutes = () => {

  return (
    <Routes>
      <Route exact path='/' element={<HomePage />} />
      <Route path='/biography' element={<Biography />} />
      <Route path='/discography' element={<Music />} />
      <Route path='/discography/:id' element={<MusicDetails />} />
      <Route path='/events' element={<Events />} />
      <Route path='/gallery/images' element={<Images />} />
      <Route path='/gallery/videos' element={<Videos />} />
      <Route path='/shop' element={<Shop />} />
      <Route path='/shop/product/:slug' element={<ProductDetails />} />
      <Route path='/checkout' element={<Checkout />} />
      <Route path='/press' element={<Press />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/terms-of-service' element={<TermsOfService />} />

      {/* User Auth Routes */}
      <Route path='/login' element={<UserPublicRoutes><LoginPage /></UserPublicRoutes>} />
      <Route path='/forgot-password' element={<UserPublicRoutes><ForgotPasswordPage /></UserPublicRoutes>} />
      <Route path='/reset-password' element={<UserPublicRoutes><ResetPasswordPage /></UserPublicRoutes>} />

      {/* User Protected Routes */}
      <Route path='/dashboard' element={<UserProtectedRoutes><UserDashboard /></UserProtectedRoutes>} />
      <Route path='/dashboard/purchase-history' element={<UserProtectedRoutes><OrderHistory /></UserProtectedRoutes>} />
      <Route path='/dashboard/change-password' element={<UserProtectedRoutes><UserChangePassword /></UserProtectedRoutes>} />

      {/* Admin Public Routes */}
      <Route path='/admin/login' element={<AdminPublicRoutes><AdminLogin /></AdminPublicRoutes>} />
      <Route path='/admin/forgot-password' element={<AdminPublicRoutes><ForgotPassword /></AdminPublicRoutes>} />
      <Route path='/admin/reset-password' element={<AdminPublicRoutes><ResetPassword /></AdminPublicRoutes>} />

      {/* Admin Protected Routes */}
      <Route element={<AdminProtectedRoutes><AdminLayout /></AdminProtectedRoutes>}>
        <Route path='/admin/dashboard' element={<Dashboard />} />
        <Route path='/admin/discography' element={<DiscographyPage />} />
        <Route path='/admin/discography/add' element={<AddMusicPage />} />
        <Route path='/admin/discography/edit/:id' element={<EditMusicPage />} />
        <Route path='/admin/events' element={<EventsPage />} />
        <Route path='/admin/events/add' element={<AddEventPage />} />
        <Route path='/admin/events/edit/:id' element={<EditEventPage />} />

        {/* Inventory Management */}
        <Route path='/admin/inventory/categories' element={<CategoriesPage />} />
        <Route path='/admin/inventory/music' element={<MusicContentPage />} />
        <Route path='/admin/inventory/merch' element={<ArtistMerchPage />} />
        <Route path='/admin/inventory/products' element={<AllProductsPage />} />
        <Route path='/admin/gallery' element={<GalleryPage />} />
        <Route path='/admin/gallery/add' element={<AddGalleryItemPage />} />
        <Route path='/admin/gallery/edit/:id' element={<EditGalleryItemPage />} />
        <Route path='/admin/press' element={<PressPage />} />
        <Route path='/admin/press/add' element={<AddPressPage />} />
        <Route path='/admin/press/edit/:id' element={<EditPressPage />} />
        <Route path='/admin/press/quotes/add' element={<AddQuotePage />} />
        <Route path='/admin/press/quotes/edit/:id' element={<EditQuotePage />} />
        <Route path='/admin/change-password' element={<ChangePassword />} />
        <Route path='/admin/subscribers' element={<SubscribersPage />} />
        <Route path='/admin/orders' element={<OrdersPage />} />
        <Route path='/admin/orders/:id' element={<OrderDetailsPage />} />
        <Route path='/admin/contacts' element={<ContactsPage />} />
        <Route path='/admin/contacts/:id' element={<ContactDetailsPage />} />
        <Route path='/admin/pages/homepage' element={<HomepageSectionSetting />} />
        <Route path='/admin/pages/contact' element={<ContactPageSetting />} />
        <Route path='/admin/pages/biography' element={<BiographyPageSetting />} />
        <Route path='/admin/epk' element={<EpkManagementPage />} />
        <Route path='/admin/epk/upload' element={<AddEpkPage />} />
      </Route>

      {/* 404 Page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};









function App() {
  // === Production HTTPS Redirection ===
  // Forcefully redirect http to https in production environments
  if (
    process.env.NODE_ENV === "production" &&
    window.location.protocol === "http:" &&
    !window.location.hostname.includes("localhost")
  ) {
    window.location.replace(window.location.href.replace("http:", "https:"));
  }

  return (
    <NotificationProvider>
      <Router>
        <CartProvider>
          <ComingSoonModal />
          <ScrollToTop />
          <AppRoutes />
        </CartProvider>
      </Router>
    </NotificationProvider>
  );
}




export default App;
